import { AuthContext } from 'common/context';
import { useContext } from 'react';

export const useAuth = () => useContext(AuthContext);
